import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-style-one',
  templateUrl: './blog-details-style-one.component.html',
  styleUrls: ['./blog-details-style-one.component.scss']
})
export class BlogDetailsStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
